export default "__VITE_ASSET__XXl3mluh__"